export type ExportSvgOptions = { transparent?: boolean };

export interface CanvasExportManager<
  PngOptions extends object,
  DataUrlOptions extends object
> {
  exportPNG: (options?: PngOptions) => void;
  exportSVG: (options?: ExportSvgOptions) => void;
  getCanvasDataUrl: (options?: DataUrlOptions) => string;
}

export abstract class ExportableCanvas<
  PngOptions extends object,
  DataUrlOptions extends object
> {
  protected abstract exportManager: CanvasExportManager<PngOptions, DataUrlOptions>;

  exportPNG(options: PngOptions = {} as PngOptions): void {
    this.exportManager.exportPNG(options);
  }

  getCanvasDataUrl(options: DataUrlOptions = {} as DataUrlOptions): string {
    return this.exportManager.getCanvasDataUrl(options);
  }

  exportSVG(options: ExportSvgOptions = {}): void {
    this.exportManager.exportSVG(options);
  }
}
